import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { request } from "@/js/http/http_request";
import { getLoggedUserData, isAdminNotConsultant, isConsultantOrHolding, isUserBuyerGroup } from "@/js/http/auth";
import { getErrorData, handleErrorData } from "@/js/forms.js";
import { orderOneClickActionTypes } from "@/js/lists.ts";
export default {
  name: "OrderOneClickAction",
  data: function data() {
    return {
      loggedUserData: {},
      orderOneClickAction: {
        guid: null,
        orderId: null,
        type: null
      },
      loading: {
        isLoading: false,
        isComplete: false,
        text: "Please wait a few moments."
      },
      errorMessage: "",
      alreadyUsedLink: false,
      clientData: {
        client_id: this.$whitelabel.clientId,
        client_secret: this.$whitelabel.clientSecret
      },
      turnstile: {
        token: null,
        isLoading: false,
        error: null,
        failedToLoad: false
      },
      orderOneClickActionTypes: orderOneClickActionTypes
    };
  },
  created: function created() {
    this.orderOneClickAction.guid = this.$route.params.guid;
    this.loggedUserData = getLoggedUserData();
    this.fetchOrderOneClickAction();
  },
  computed: {
    isRequestFinishedWithError: function isRequestFinishedWithError() {
      return !this.loading.isComplete && this.errorMessage;
    },
    isLogged: function isLogged() {
      var _this$loggedUserData;
      return +((_this$loggedUserData = this.loggedUserData) === null || _this$loggedUserData === void 0 ? void 0 : _this$loggedUserData.idUser) > 0;
    },
    turnstileKey: function turnstileKey() {
      return process.env.VUE_APP_CLOUDFLARE_CAPTCHA_SITE_KEY;
    }
  },
  methods: {
    setupTurnstile: function setupTurnstile() {
      var _this2 = this;
      this.$nextTick(function () {
        if (window.turnstile && _this2.$refs.turnstile) {
          _this2.turnstile.isLoading = true;
          var timeout = setTimeout(function () {
            if (!_this2.turnstile.token) {
              _this2.turnstile.failedToLoad = true;
              _this2.turnstile.isLoading = false;
            }
          }, 6000);
          window.turnstile.render(_this2.$refs.turnstile, {
            sitekey: process.env.VUE_APP_CLOUDFLARE_CAPTCHA_SITE_KEY,
            theme: "dark",
            callback: function callback(token) {
              clearTimeout(timeout);
              _this2.turnstile.token = token;
              _this2.turnstile.isLoading = false;
            },
            "expired-callback": function expiredCallback() {
              _this2.turnstile.token = null;
            },
            "error-callback": function errorCallback() {
              _this2.turnstile.token = false;
              _this2.$toasted.error("An error occurred with the CAPTCHA. Please try again by refreshing the page.");
            }
          });
        } else {
          console.error("Turnstile or container not found");
          _this2.turnstile.failedToLoad = true;
          _this2.turnstile.isLoading = false;
          _this2.turnstile.error = "CAPTCHA service is unavailable. You can continue without it.";
        }
      });
    },
    fetchOrderOneClickAction: function fetchOrderOneClickAction() {
      this.loading.isLoading = true;
      var _this = this;
      request("/v1/one-click-action/order/" + this.orderOneClickAction.guid, "post", _this.clientData, false, "api").then(function (resp) {
        _this.orderOneClickAction = resp.data;
        if (_this.orderOneClickAction.usageDate != null) {
          if (_this.isAdminNotConsultant(_this.loggedUserData)) {
            _this.loading.text = "This link is not available anymore. You are redirected to the order page.";
            _this.goToOrderDetails();
          } else {
            _this.alreadyUsedLink = true;
          }
          _this.loading.isLoading = false;
          return;
        }
        _this.loading.isLoading = false;
        _this.setupTurnstile();
      }).catch(function (e) {
        _this.loading.isLoading = false;
        _this.manageErrors(e);
      });
    },
    updateOrderOneClickAction: function updateOrderOneClickAction() {
      this.loading.isLoading = true;
      if (this.orderOneClickAction.type == orderOneClickActionTypes.CUSTOMER_APPROVE.id) {
        this.loading.text = "Your order is updating, please wait a few moments.";
      } else {
        this.loading.text = "We are cancelling your order, please wait a few moments.";
      }
      var _this = this;
      request("/v1/one-click-action/order/" + this.orderOneClickAction.guid + "/update", "post", _this.clientData, false, "api").then(function (_) {
        _this.loading.isLoading = false;
        _this.loading.isComplete = true;
      }).catch(function (e) {
        _this.loading.isLoading = false;
        _this.manageErrors(e);
      });
    },
    goToOrderDetails: function goToOrderDetails() {
      if (this.isAdminNotConsultant(this.loggedUserData)) {
        this.$router.push({
          name: "adminOrderSummary",
          params: {
            id: this.orderOneClickAction.orderId
          }
        });
      } else if (this.isConsultantOrHolding(this.loggedUserData)) {
        this.$router.push({
          name: "consultantOrderDetails",
          params: {
            id: this.orderOneClickAction.orderId
          }
        });
      } else if (this.isUserBuyerGroup(this.loggedUserData)) {
        this.$router.push({
          name: "userOrderSummary",
          params: {
            id: this.orderOneClickAction.orderId
          }
        });
      }
    },
    verifyCaptchaAndFetchOrder: function verifyCaptchaAndFetchOrder() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isValid;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this3.turnstile.token && !_this3.turnstile.failedToLoad)) {
                _context.next = 3;
                break;
              }
              _this3.turnstile.error = "Please complete the CAPTCHA before proceeding.";
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return _this3.verifyCaptcha(_this3.turnstile.token);
            case 6:
              isValid = _context.sent;
              if (!isValid) {
                _context.next = 14;
                break;
              }
              _context.next = 10;
              return _this3.updateOrderOneClickAction();
            case 10:
              _this3.turnstile.error = null;
              _this3.turnstile.token = null;
              _context.next = 15;
              break;
            case 14:
              _this3.turnstile.error = "CAPTCHA verification failed. Please try again.";
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              _this3.turnstile.error = "An error occurred while verifying the CAPTCHA. Please try again.";
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 17]]);
      }))();
    },
    verifyCaptcha: function verifyCaptcha(token) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, resp;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this4;
              _context2.next = 3;
              return request("/v1/orders/verify-turnstile/".concat(token), "post", _this.clientData, false, "api").catch(function (e) {
                return false;
              });
            case 3:
              resp = _context2.sent;
              return _context2.abrupt("return", resp.data.value);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    manageErrors: function manageErrors(e) {
      var _e$response, _e$response2;
      if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode) === "guid_already_used") {
        if (this.isAdminNotConsultant(this.loggedUserData)) {
          this.goToOrderDetails();
        } else {
          this.errorMessage = "This link is not available anymore.";
        }
        return;
      }
      if ((e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.value) === null || _e$response2 === void 0 ? void 0 : _e$response2.errorCode) === "wrong_status_update") {
        if (this.isAdminNotConsultant(this.loggedUserData)) {
          this.goToOrderDetails();
        } else {
          this.errorMessage = "The current order status does not allow updates using this link.";
        }
        return;
      }
      var errorData = getErrorData(e, this.managedExceptions, "Unable to update the order", true);
      handleErrorData(this, errorData);
    },
    refreshPage: function refreshPage() {
      this.$router.go(0);
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding,
    isUserBuyerGroup: isUserBuyerGroup
  }
};